import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import MaintainPlanList from './components/MaintainPlanList';

const { Cell } = ResponsiveGrid;

const MachineInspect = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="年度維護計畫"
        breadcrumbs={[
          {
            name: '年度維護計畫',
          },
          {
            name: '年度維護計劃表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <MaintainPlanList />
    </Cell>
  </ResponsiveGrid>
);

export default MachineInspect;
